import React from 'react'
import { twMerge } from 'tailwind-merge'

import { TimeIcon } from '../../icons/line/TimeIcon'
import { Icon } from '../icon'
import { NavTabSlot } from '../nav-tab-slot'
import { Pressable } from '../pressable'
import { Text } from '../text'
import { type NavTimeButtonProps } from './NavTimeButton.types'

/**
 * The "jump to now" control every module top bar carries: the clock glyph and the
 * current time, never a literal "Now" label (AOS-1355). Figma NavItem stacks them in
 * the flight-table slots (9539:126646) and sets them in a row, `layout=wide`, on the
 * task and event timeline bars (9387:103714, AOS-1395).
 */
export function NavTimeButton({
    time,
    onPress,
    disabled = false,
    layout = 'stacked',
    accessibilityLabel,
    testID,
    className,
}: NavTimeButtonProps) {
    return (
        <NavTabSlot className={className}>
            <Pressable
                accessibilityRole='button'
                accessibilityLabel={accessibilityLabel}
                testID={testID}
                disabled={disabled}
                onPress={disabled ? undefined : onPress}
                className={twMerge(
                    'h-full w-full items-center justify-center gap-2',
                    layout === 'wide' ? 'flex-row' : 'flex-col',
                    disabled && 'opacity-40',
                )}
            >
                <Icon as={TimeIcon} size={24} className='text-content-default' />
                <Text size='body' weight='medium' tone='default'>
                    {time}
                </Text>
            </Pressable>
        </NavTabSlot>
    )
}

NavTimeButton.displayName = 'NavTimeButton'
